/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';

import Text from 'components/styled/Text';
import { Flex, Box } from 'components/styled';

import { HomepageCardModal } from './ModalCards';

export type THomepageCard = {
	Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
	title: string;
	desc: string;
	card: React.FC;
	to: string;
};

const HomepageCard: FC<THomepageCard> = ({ title, desc, Icon, card, to }) => {
	return (
		<Flex bg="white" p={4} flexDirection="column">
			{Icon && (
				<Flex
					width={70}
					height={70}
					bg="lightGrey"
					justifyContent="center"
					alignItems="center"
					color="primary"
					mb={3}
				>
					<Icon />
				</Flex>
			)}
			<Text as="h3" m={0} color="primary">
				{title}
			</Text>
			<Text mb={3} color="secondary">
				{desc}
			</Text>
			<Box alignSelf="flex-end" mt="auto">
				<HomepageCardModal title={title} card={card} to={to} />
			</Box>
		</Flex>
	);
};
export default HomepageCard;
